__turbopack_context__.v({
  "breadcrumbs": "Breadcrumbs-module__1oWJ9a__breadcrumbs",
});
